import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from "react-redux";
import { Navigate } from 'react-router-dom';
import { PDFViewer } from '@react-pdf/renderer';
import ReactPDF, { Page, Text, View, Document, StyleSheet, Image, Font, PDFDownloadLink, Svg } from '@react-pdf/renderer';
import { styled } from '@mui/material/styles';
import axios from "axios";
import "./styles.css";
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Switch,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
} from '@mui/material';
// components
import Label from '../components/label';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
import SwitchStyled from "./SwitchStyled";
// sections
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';
// mock

// ----------------------------------------------------------------------

const TABLE_HEAD_ACCOUNTANTS = [
  { id: 'ime', label: 'Ime', alignRight: false },
  { id: 'prezime', label: 'Prezime', alignRight: false },
  { id: 'telefon', label: 'Telefon', alignRight: false },
  { id: 'mjesto', label: 'Mjesto', alignRight: false },
  { id: 'drzava', label: 'Drzava', alignRight: false },
  { id: 'select', label: 'Select', alignRight: false }
];

const TABLE_HEAD_BILLS = [
  { id: 'broj', label: 'Broj', alignRight: false },
  { id: 'device', label: 'Uređaj', alignRight: false },
  { id: 'datum', label: 'Datum', alignRight: false },
  { id: 'datum_old', label: 'Datum stari', alignRight: false },
  { id: 'datum_novi', label: 'Datum novi', alignRight: false },
  { id: 'subscriber', label: 'Pretplatnik', alignRight: false },
  { id: 'accountant', label: 'Accountant', alignRight: false },
  { id: 'iznos', label: 'Iznos', alignRight: false },
  { id: 'booked', label: 'Booked', alignRight: false }
];

// ----------------------------------------------------------------------

function getAccountantfromUser(roles) {
  let result = roles.substring(10, roles.length);
  return result;
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilterAccountants(array, comparator, query, field) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  
  if (query) {  
	if (field === 'ime')
    return filter(array, (_user) => _user.ime.toLowerCase().indexOf(query.toLowerCase()) !== -1);

	if (field === 'prezime')
    return filter(array, (_user) => _user.prezime.toLowerCase().indexOf(query.toLowerCase()) !== -1);

	if (field === 'telefon')
    return filter(array, (_user) => _user.telefon.toLowerCase().indexOf(query.toLowerCase()) !== -1);

	if (field === 'mjesto')
    return filter(array, (_user) => _user.mjesto.toLowerCase().indexOf(query.toLowerCase()) !== -1);

	if (field === 'drzava')
    return filter(array, (_user) => _user.drzava.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

function applySortFilterBills(array, comparator, query, field) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    if (field === 'device')
    return filter(array, (_user) => _user.device.IMEI.toLowerCase().indexOf(query.toLowerCase()) !== -1);

    if (field === 'subscriber')
    return filter(array, (_user) => _user.device.subscriber.ime.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

function useForceUpdate() {
    const [value, setValue] = useState(0); // integer state
    return () => setValue(value => value + 1); // update state to force render
    // A function that increment 👆🏻 the previous state like here 
    // is better than directly setting `setValue(value + 1)`
}

export default function BillsReportAll() {
	
  const [accountants, setAccountants] = useState([]);
  const [accountantsdataloaded, setAccountantsDataLoaded] = useState(false);
  
  const [accountantimeprezime, setAccountantImePrezime] = useState('');
  
  const [bills, setBills] = useState([]);
  const [billsdataloaded, setBillsDataLoaded] = useState(false);
  
  const [accountant, setAccountant] = useState('0');
  
  
  const [showtrophyreport, setShowTrophyReport] = useState(false);
  
  const [loading, setLoading] = useState(false);
  
  
  const [pageAccountants, setPageAccountants] = useState(0);

  const [orderAccountants, setOrderAccountants] = useState('asc');
  
  const [selectedAccountants, setSelectedAccountants] = useState([]);

  const [orderByAccountants, setOrderByAccountants] = useState('id');

  const [filterNameAccountants, setFilterNameAccountants] = useState('');

  const [rowsPerPageAccountants, setRowsPerPageAccountants] = useState(5);
  
	
  const [pageBills, setPageBills] = useState(0);

  const [orderBills, setOrderBills] = useState('asc');
  
  const [selectedBills, setSelectedBills] = useState([]);

  const [orderByBills, setOrderByBills] = useState('id');

  const [filterNameBills, setFilterNameBills] = useState('');

  const [rowsPerPageBills, setRowsPerPageBills] = useState(5);
  
  
  const forceUpdate = useForceUpdate();
  
  const { user: currentUser } = useSelector((state) => state.auth);
  
  const SERVER_URL = process.env.REACT_APP_BACKEND_SERVER_URL;
  
  useEffect(() => {
	  
  console.log(accountantsdataloaded);
  if (!accountantsdataloaded) {
    getAllAccountants();
  } 
  
  console.log(billsdataloaded);
  if (!billsdataloaded) {
    getAllBills();
  }  
  });
  
  if (!currentUser) {
    return <Navigate to="/login" />;
  }
    
  const handleChange = (event, id) => {
	 	
    var array = bills;
	
	const objectWithSpecificId = array.find(
		obj => obj.id === id
	);
	
	axios.put("https://gpsdogstracking.com:3000/api/bills/" + id,
		{
		"booked": !objectWithSpecificId.booked
		}
	).then(() => {
		// getAllHunters();
		objectWithSpecificId.booked = !objectWithSpecificId.booked;

		setBills(array);
		forceUpdate(); 
	});
  };
  
  const getAllAccountants = async () => {
      try {
        const response = await axios.get(SERVER_URL + "/accountants");
        setAccountants(response.data);
		setAccountantsDataLoaded(true);
		console.log(response.data);
      } catch (err) {
        console.log("error");
      }
  };
  
  const getAllBills = async () => {
      try {
        const response = await axios.get(SERVER_URL + "/bills" + "?accountantId=" + accountant);
        setBills(response.data);
		setBillsDataLoaded(true);
		console.log(response.data);
      } catch (err) {
        console.log("error");
      }
  };
   
  console.log(currentUser);
  console.log(getAccountantfromUser(currentUser.roles[0]));
  
  if (!currentUser) {
    return <Navigate to="/login" />;
  }
    
  const handleOpenMenu = (event) => {
    //setOpen(event.currentTarget);
  };

  const handleCloseMenu = () => {
    //setOpen(null);
  };

  const handleRequestSortAccountants = (event, property) => {
    const isAsc = orderByAccountants === property && orderAccountants === 'asc';
    setOrderAccountants(isAsc ? 'desc' : 'asc');
    setOrderByAccountants(property);
	console.log(property);
  };

  const handleSelectAllClickAccountants = (event) => {
    if (event.target.checked) {
      const newSelecteds = bills.map((n) => n.id);
      setSelectedAccountants(newSelecteds);
      return;
    }
    setSelectedAccountants([]);
  };
  
    const handleRequestSortBills = (event, property) => {
    const isAsc = orderByBills === property && orderBills === 'asc';
    setOrderBills(isAsc ? 'desc' : 'asc');
    setOrderByBills(property);
	console.log(property);
  };

  const handleSelectAllClickBills = (event) => {
    if (event.target.checked) {
      const newSelecteds = bills.map((n) => n.id);
      setSelectedBills(newSelecteds);
      return;
    }
    setSelectedBills([]);
  };

  const handleClick = (event, id, ime, prezime) => {
	console.log(id);
	setAccountant(id);
	setAccountantImePrezime(ime + ' ' + prezime);
	setBillsDataLoaded(false);
	setPageAccountants(0);
	setPageBills(0);
  };
    
  const handleChangePageAccountants = (event, newPage) => {
    setPageAccountants(newPage);
  };

  const handleChangeRowsPerPageAccountants = (event) => {
    setPageAccountants(0);
    setRowsPerPageAccountants(parseInt(event.target.value, 10));
  };

  const handleFilterByNameAccountants = (event) => {
    setPageAccountants(0);
    setFilterNameAccountants(event.target.value);
  };
  
  const handleChangePageBills = (event, newPage) => {
    setPageBills(newPage);
  };

  const handleChangeRowsPerPageBills = (event) => {
    setPageBills(0);
    setRowsPerPageBills(parseInt(event.target.value, 10));
  };

  const handleFilterByNameBills = (event) => {
    setPageBills(0);
    setFilterNameBills(event.target.value);
  };
  
  
  const emptyRowsAccountants = pageAccountants > 0 ? Math.max(0, (1 + pageAccountants) * rowsPerPageAccountants - accountants.length) : 0;
  
  const emptyRowsBills = pageBills > 0 ? Math.max(0, (1 + pageBills) * rowsPerPageBills - bills.length) : 0;
  
  
  const filteredAccountants = applySortFilterAccountants(accountants, getComparator(orderAccountants, orderByAccountants), filterNameAccountants, orderByAccountants);

  const filteredBills = applySortFilterBills(bills, getComparator(orderBills, orderByBills), filterNameBills, orderByBills);
  
  
  var today = new Date();

  const datum ='Datum: ' +  today.getDate()  + '.' + (today.getMonth() + 1) + '.' + today.getFullYear() + '. god.';

Font.register({
  family: "Roboto",
  src:
    "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-light-webfont.ttf"
});

  const styles = StyleSheet.create({
  page: {
    fontFamily: "Roboto"
  },
  body: {
    paddingTop: 50,
    paddingBottom: 65,
    paddingHorizontal: 30,
	fontFamily: "Roboto", 
	fontSize: 10,
  },
  title: {
    fontSize: 24,
    textAlign: 'center',
    fontFamily: 'Roboto'
  },
  author: {
    fontSize: 12,
    textAlign: 'center',
    marginBottom: 40,
  },
  subtitle: {
    fontSize: 18,
    margin: 12,
    fontFamily: 'Roboto'
  },
  text: {
    margin: 5,
    fontSize: 12,
    textAlign: 'justify',
    fontFamily: 'Roboto',
	paddingHorizontal: 20,
  },
  textmedium: {
    margin: 3,
    fontSize: 12,
    textAlign: 'justify',
    fontFamily: 'Roboto',
	paddingHorizontal: 20,
  },
  textmediumlarge: {
    margin: 12,
    fontSize: 20,
    textAlign: 'justify',
    fontFamily: 'Roboto'
  },
  textbig: {
    margin: 12,
    fontSize: 28,
    textAlign: 'justify',
    fontFamily: 'Roboto'
  },
  image: {
    marginVertical: 15,
    marginHorizontal: 100,
  },
  header: {
    fontSize: 12,
    marginBottom: 20,
    textAlign: 'center',
    color: 'grey',
  },
  pageNumber: {
    position: 'absolute',
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'grey',
  },
  officer: {
	paddingTop: 70,
    fontSize: 12,
	margin: 0,
    fontSize: 12,
    fontFamily: 'Roboto',
	left: 150,
  },
  officertext: {
    margin: 0,
    fontSize: 12,
    textAlign: 'center',
    fontFamily: 'Roboto',
  },
  mp: {
    position: 'absolute',
    fontSize: 12,
    bottom: 100,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'grey'
  },
  table: { 
    display: "table", 
    width: "auto", 
    borderStyle: "solid",  
    borderRightWidth: 0, 
	borderLefttWidth: 0, 
    borderTopWidth: 0,
	borderBottomWidth: 0,
  }, 
  tableRow: { 
    margin: "0", 
    flexDirection: "row",
	 borderWidth: 0,
  }, 
  tableCol: { 
    width: "20%", 
    borderStyle: "solid", 
    borderWidth: 0, 
    borderLeftWidth: 0, 
    borderTopWidth: 0 
  }, 
  tableColLong: { 
    width: "35%", 
    borderStyle: "solid", 
    borderWidth: 0, 
    borderLeftWidth: 0, 
    borderTopWidth: 0 
  },
  tableColShort: { 
    width: "15%", 
    borderStyle: "solid", 
    borderWidth: 0, 
    borderLeftWidth: 0, 
    borderTopWidth: 0 
  },
  tableColVeryShort: { 
    width: "5%", 
    borderStyle: "solid", 
    borderWidth: 0, 
    borderLeftWidth: 0, 
    borderTopWidth: 0 
  },
  tableCell: { 
    margin: "auto", 
    marginTop: 5, 
    fontSize: 10 
  },
});

  const TrophiesReportAll = () => (
	<Document>
    <Page size="A4" orientation="landscape" scale={0.5} style={styles.body} wrap>

	
	<Svg style={styles.text} width="800" height="150" viewBox="0 0 800 100">
		<Text style={styles.textmediumlarge} x="270" y="80">Evidencija naplate</Text>
		<Text style={styles.textmediumlarge} x="295" y="110">{accountantimeprezime}</Text>
	</Svg>	
	
	<View wrap style={styles.body}> 
      <View style={styles.table}> 
        <View wrap={false} style={styles.tableRow}> 
          <View style={styles.tableColVeryShort}> 
            <Text style={styles.tableCell}>Broj</Text> 
          </View> 
          <View style={styles.tableColShort}> 
            <Text style={styles.tableCell}>Uplata</Text> 
          </View> 
          <View style={styles.tableColLong}> 
            <Text style={styles.tableCell}>Pretplatnik</Text> 
          </View> 
          <View style={styles.tableColLong}> 
            <Text style={styles.tableCell}>Pas</Text> 
          </View> 
		  <View style={styles.tableColLong}> 
            <Text style={styles.tableCell}>IMEI</Text> 
          </View> 
	      <View style={styles.tableColLong}> 
            <Text style={styles.tableCell}>Datum</Text> 
          </View> 
          <View style={styles.tableColLong}> 
            <Text style={styles.tableCell}>Datum stari</Text> 
          </View> 
          <View style={styles.tableColLong}> 
            <Text style={styles.tableCell}>Datum novi</Text> 
          </View> 
		  <View style={styles.tableColShort}> 
            <Text style={styles.tableCell}>Iznos</Text> 
          </View> 
		  <View style={styles.tableColShort}> 
            <Text style={styles.tableCell}>Booked</Text> 
          </View> 
        </View>
		
    {filteredBills.map((bill, index) => (
	
	true && ( 
		<View key = {bill.id} wrap={false} style={styles.tableRow}> 
          <View wrap={false} style={styles.tableColVeryShort}> 
            <Text style={styles.tableCell}>{index + 1}.</Text> 
          </View> 
          <View wrap={false} style={styles.tableColShort}> 
            <Text style={styles.tableCell}>{bill.id}</Text> 
          </View> 
          <View wrap={false} style={styles.tableColLong}> 
            <Text style={styles.tableCell}>{bill.device.subscriber.ime} {bill.device.subscriber.prezime}</Text> 
          </View> 
          <View wrap={false} style={styles.tableColLong}> 
            <Text style={styles.tableCell}>{bill.device.ime}</Text> 
          </View> 
          <View wrap={false} style={styles.tableColLong}> 
            <Text style={styles.tableCell}>{bill.device.IMEI}</Text> 
          </View> 
          <View wrap={false} style={styles.tableColLong}> 
            <Text style={styles.tableCell}>{bill.datum}</Text> 
          </View> 
		  <View wrap={false} style={styles.tableColLong}> 
            <Text style={styles.tableCell}>{bill.datum_end_old}</Text> 
          </View> 
		  <View wrap={false} style={styles.tableColLong}> 
            <Text style={styles.tableCell}>{bill.datum_end_new}</Text> 
          </View> 
		  <View wrap={false} style={styles.tableColShort}> 
            <Text style={styles.tableCell}>{bill.iznos} E</Text> 
          </View> 
		  <View wrap={false} style={styles.tableColShort}> 
            <Text style={styles.tableCell}>{bill.booked}</Text> 
          </View> 
        </View> 
	  )
    ))}
      </View>
	</View>
	  
    <View size="A4" style={styles.officer}>	 
	<Text size="A4" style={styles.officertext} ></Text>
	<Text size="A4" style={styles.officertext} >______________________________</Text>
	<Text size="A4" style={styles.officertext} >(Računovođa)</Text>
	</View>	
	
	<Text size="A4" style={styles.mp}>
		M.P.
	</Text>

    <Text
        style={styles.pageNumber}
        render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
        fixed
    />
    </Page>
	</Document>
  )

  const Android12Switch = styled(Switch)(({ theme }) => ({
  padding: 8,
  '& .MuiSwitch-track': {
    borderRadius: 22 / 2,
    '&:before, &:after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      width: 16,
      height: 16,
    },
    '&:before': {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main),
      )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
      left: 12,
    },
    '&:after': {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main),
      )}" d="M19,13H5V11H19V13Z" /></svg>')`,
      right: 12,
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: 'none',
    width: 16,
    height: 16,
    margin: 2,
  },
}));

  return (
    <>
      <Helmet>
        <title>  GPS Dogs Tracking System </title>
      </Helmet>
	 
      <Container maxWidth="xl">		
		<Typography variant="subtitle2" noWrap>
		Accountants 
		</Typography>
		
        <Card>
          <UserListToolbar numSelected={selectedAccountants.length} filterName={filterNameAccountants} onFilterName={handleFilterByNameAccountants} />
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
				  color='#002884'
                  order={orderAccountants}
                  orderBy={orderByAccountants}
                  headLabel={TABLE_HEAD_ACCOUNTANTS}
                  rowCount={accountants.length}
                  numSelected={selectedAccountants.length}
                  onRequestSort={handleRequestSortAccountants}
                  onSelectAllClick={handleSelectAllClickAccountants}
                />
                <TableBody>
                  {filteredAccountants.slice(pageAccountants * rowsPerPageAccountants, pageAccountants * rowsPerPageAccountants + rowsPerPageAccountants).map((row) => {
                    const { id, ime, prezime, telefon, mjesto, drzava } = row; 
					
					
                    const selectedUser = selectedAccountants.indexOf(id) !== -1;

                    return (
                      <TableRow hover key={id} tabIndex={-1} role="checkbox" selectedAccountants={selectedUser}>
					  
                        <TableCell component="th" scope="row" >
                          <Stack direction="row" alignItems="center" spacing={2}>
                            <Avatar alt={id} src={"/assets/images/accountants/photo_" + id + ".jpg"} sx={{ width: 50, height: 50 }} variant="rounded"/>
                          </Stack>
                        </TableCell>
						
						<TableCell align="left">
						<Typography variant="subtitle2" noWrap>
						{ime}
						</Typography>
						</TableCell>

						<TableCell align="left">
						<Typography variant="subtitle2" noWrap>
						{prezime}
						</Typography>
						</TableCell>
						
						<TableCell align="left">
						<Typography variant="subtitle2" noWrap>
						{telefon}
						</Typography>
						</TableCell>
						
						<TableCell align="left">
						<Typography variant="subtitle2" noWrap>
						{mjesto}
						</Typography>
						</TableCell>
						
						<TableCell align="left">
						<Typography variant="subtitle2" noWrap>
						{drzava}
						</Typography>
						</TableCell>

						<TableCell> 
						<Button onClick={(event) => handleClick(event, id, ime, prezime)}>Select</Button>
						</TableCell>
						
                      </TableRow>
                    );
                  })}
                  {emptyRowsAccountants > 0 && (
                    <TableRow style={{ height: 53 * emptyRowsAccountants }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={filteredAccountants.length}
            rowsPerPage={rowsPerPageAccountants}
            page={pageAccountants}
            onPageChange={handleChangePageAccountants}
            onRowsPerPageChange={handleChangeRowsPerPageAccountants}
          />
        </Card>
		
        <Card>
          <UserListToolbar numSelected={selectedBills.length} filterName={filterNameBills} onFilterName={handleFilterByNameBills} />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
				  color='#002884'
                  order={orderBills}
                  orderBy={orderByBills}
                  headLabel={TABLE_HEAD_BILLS}
                  rowCount={bills.length}
                  numSelected={selectedBills.length}
                  onRequestSort={handleRequestSortBills}
                  onSelectAllClick={handleSelectAllClickBills}
                />
                <TableBody>
                  {filteredBills.slice(pageBills * rowsPerPageBills, pageBills * rowsPerPageBills + rowsPerPageBills).map((row) => {
                    const { id, accountantId, accountant, deviceId, device, datum, datum_end_old, datum_end_new, iznos, booked } = row; 
					
					
                    const selectedUser = selectedBills.indexOf(id) !== -1;

                    return (
                      <TableRow hover key={id} tabIndex={-1} role="checkbox" selected={selectedUser}>
                        <TableCell component="th" scope="row" >
                          <Stack direction="row" alignItems="center" spacing={2}>
                            <Avatar alt={device.tip} src={"/assets/images/lovackipsi/" + device.tip + ".jpg"} sx={{ width: 50, height: 50 }} variant="rounded"/>
							<Avatar alt={device.tiptrackera} src={"/assets/images/trackers/" + device.tiptrackera + ".jpg"} sx={{ width: 30, height: 30 }} variant="rounded"/>
                          </Stack>
                        </TableCell>
						
						<TableCell align="left">
						<Typography variant="subtitle2" noWrap>
						{id}
						</Typography>
						</TableCell>
												
						<TableCell align="left">
						<Typography variant="subtitle2" noWrap>
						id: {deviceId}
						<br />
						ime: {device.ime}
						<br />
						IMEI: {device.IMEI}
					    <br />
						Saldo: {device.saldo}
						</Typography>
						</TableCell>

						<TableCell align="left">
						<Typography variant="subtitle2" noWrap>
						{datum}
						</Typography>
						</TableCell>	

						<TableCell align="left">
						<Typography variant="subtitle2" noWrap>
						{datum_end_old}
						</Typography>
						</TableCell>	

						<TableCell align="left">
						<Typography variant="subtitle2" noWrap>
						{datum_end_new}
						</Typography>
						</TableCell>

						<TableCell align="left">
						<Typography variant="subtitle2" noWrap>
						Ime i prezime: {device.subscriber.ime} {device.subscriber.prezime}
						<br />
						Mjesto: {device.subscriber.mjesto}
						<br />
						Država: {device.subscriber.drzava}
						</Typography>
						</TableCell>	

						<TableCell align="left">
						<Typography variant="subtitle2" noWrap>
						{accountant.ime} {accountant.ime}
						</Typography>
						</TableCell>	

						<TableCell align="left">
						<Typography variant="subtitle2" noWrap>
						{iznos} E
						</Typography>
						</TableCell>

						<TableCell align="left">					
						<Checkbox
						color="success"
						checked={booked}
						onChange={(event) => handleChange(event, id)}
						inputProps={{ 'aria-label': 'controlled' }}
						/>
						</TableCell>						
						
                      </TableRow>
                    );
                  })}
                  {emptyRowsBills > 0 && (
                    <TableRow style={{ height: 53 * emptyRowsBills }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={filteredBills.length}
            rowsPerPage={rowsPerPageBills}
            page={pageBills}
            onPageChange={handleChangePageBills}
            onRowsPerPageChange={handleChangeRowsPerPageBills}
          />
        </Card>
				
		<br />
		
		<Button onClick={() => setLoading(!loading)}>Generate Bills Report</Button>
		
		{loading ? ( 
		<div className = "child">	 
		<PDFViewer className = "child">
		<TrophiesReportAll />
		</PDFViewer>
		</div>	
		)
		:
		(
		<>
		</>
		)
		}
	
      </Container>
	  
    </>
  );
}